<template>
    <nav class="navbar navbar-expand-lg fixed-top" :class="{'scrolled': dark}">
        <div class="container">
            <a class="navbar-brand" href="#"><img src="@/assets/images/logo.png" class="logo"></a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon logo"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto text-right">
                    <li class="nav-item active mr-2">
                        <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
                    </li>
                    <li class="nav-item mr-2"><a class="nav-link" href="#services">Servizi</a></li>
                    <li class="nav-item mr-2"><a class="nav-link" href="#architettura">Architettura</a></li>
                    <li class="nav-item mr-2"><a class="nav-link" href="#design">Design</a></li>
                    <li class="nav-item mr-2"><a class="nav-link" href="#industria">Industria</a></li>
                    <li class="nav-item mr-2"><a class="nav-link" href="#gallery">Gallery</a></li>
                    <li class="nav-item mr-2"><a class="nav-link" href="#contatti">Contatti</a></li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "Navbar",
        data() {
            return {
                dark: false
            }
        },
        methods: {
            handleScroll(e) {
                if (!this.lockDark) {
                    let scrollTop = e.target.scrollingElement.scrollTop
                    if (scrollTop > 550) {
                        this.dark = true;
                        this.src = this.srcGold
                    } else {
                        this.dark = false;
                    }
                }
            }
        },
        created() {
            document.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            document.removeEventListener('scroll', this.handleScroll)
        }
    }
</script>

<style scoped>
    .logo {
        height: 1.3rem;
    }
</style>